import { css, Global } from '@emotion/react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useCallback, useState } from 'react'

const AgentWidget = dynamic(
  () => import('components/didAgent/AgentWidget').then((module) => module.AgentWidget),
  { ssr: false }
)

const isConfigured = Boolean(
  process.env.NEXT_PUBLIC_DID_AGENT_ID && process.env.NEXT_PUBLIC_DID_CLIENT_KEY
)

const hideFreshDeskButton = css`
  iframe#launcher-frame {
    display: none !important;
  }
`

export function DidAgent() {
  const { pathname } = useRouter()
  const [isUnavailable, setIsUnavailable] = useState(false)
  const onUnavailable = useCallback(() => setIsUnavailable(true), [])

  // On every page, so a call carries on wherever the visitor goes, but not in the pages partners
  // embed in their own sites
  if (!isConfigured || pathname.startsWith('/iframe')) return null

  return (
    <>
      {/* Freshdesk's Help button sits in Mia's corner. She stands in for it.
      Rendered on the server, so the button never shows before she has loaded; it comes
      back when she cannot be loaded. */}
      {!isUnavailable && <Global styles={hideFreshDeskButton} />}
      <AgentWidget onUnavailable={onUnavailable} />
    </>
  )
}
